import { call, put, takeEvery } from "redux-saga/effects";

import * as apis from "../../../network/apis/companyPortalRoles";
import {
  getCompanyRolesListMeta,
  normalizeCompanyRole,
  normalizeCompanyRoles,
} from "../../../containers/Company-portal/TeamsPermissions/roleMappers";
import { showErrorMsg, showSuccessMsg } from "../../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

const extractListItems = (response) => response?.data?.data ?? [];

function* getCompanyRolesSaga({ payload }) {
  try {
    const response = yield call(apis.getCompanyRoles, payload);
    yield put(
      actions.getCompanyRolesResponse({
        list: normalizeCompanyRoles(extractListItems(response)),
        meta: getCompanyRolesListMeta(response),
      }),
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* createCompanyRoleSaga({ payload }) {
  const { data, onSuccess, onError } = payload || {};
  try {
    const response = yield call(apis.createCompanyRole, data);
    yield put(actions.createCompanyRoleSuccess(response?.data?.data));
    yield showSuccessMsg("addedSuccessfully");
    if (typeof onSuccess === "function") onSuccess(response);
  } catch (error) {
    const message = error?.response?.data?.message;
    yield put(actions.createCompanyRoleFailure({ error: message }));
    if (message) yield showErrorMsg(message);
    if (typeof onError === "function") onError(error);
  }
}

function* getCompanyRoleSaga({ payload }) {
  const { id, onError } = payload || {};
  try {
    const response = yield call(apis.getCompanyRole, id);
    yield put(
      actions.getCompanyRoleResponse(normalizeCompanyRole(response?.data?.data)),
    );
  } catch (error) {
    yield put(actions.getCompanyRoleResponse(null));
    const message = error?.response?.data?.message;
    if (message) yield showErrorMsg(message);
    if (typeof onError === "function") onError(error);
  }
}

function* updateCompanyRoleSaga({ payload }) {
  const { id, data, successMessage, onSuccess, onError } = payload || {};
  try {
    const response = yield call(apis.updateCompanyRole, { id, data });
    yield put(
      actions.updateCompanyRoleSuccess(
        normalizeCompanyRole(response?.data?.data),
      ),
    );
    if (successMessage) yield showSuccessMsg(successMessage, true);
    if (typeof onSuccess === "function") onSuccess(response);
  } catch (error) {
    const message = error?.response?.data?.message;
    yield put(actions.updateCompanyRoleFailure({ error: message }));
    if (message) yield showErrorMsg(message);
    if (typeof onError === "function") onError(error);
  }
}

function* deleteCompanyRoleSaga({ payload }) {
  const { id, onSuccess, onError } = payload || {};
  try {
    const response = yield call(apis.deleteCompanyRole, id);
    yield put(actions.deleteCompanyRoleSuccess({ id }));
    const message = response?.data?.message;
    if (message) yield showSuccessMsg(message, true);
    else yield showSuccessMsg("deletedSuccessfully");
    if (typeof onSuccess === "function") onSuccess(response);
  } catch (error) {
    const message = error?.response?.data?.message;
    yield put(actions.deleteCompanyRoleFailure({ error: message }));
    if (message) yield showErrorMsg(message);
    if (typeof onError === "function") onError(error);
  }
}

export default function* companyRolesSagas() {
  yield takeEvery(types.GET_COMPANY_ROLES_REQUEST, getCompanyRolesSaga);
  yield takeEvery(types.CREATE_COMPANY_ROLE_REQUEST, createCompanyRoleSaga);
  yield takeEvery(types.GET_COMPANY_ROLE_REQUEST, getCompanyRoleSaga);
  yield takeEvery(types.UPDATE_COMPANY_ROLE_REQUEST, updateCompanyRoleSaga);
  yield takeEvery(types.DELETE_COMPANY_ROLE_REQUEST, deleteCompanyRoleSaga);
}
